import React, { useRef, useEffect, useCallback, useState} from 'react';
import Day from '../Day.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import {useScroll} from '../useScroll.js';
import {connect} from 'react-redux';

let id = 0;

const ContentGrid = ({
    onClickSource,
    searchTerm,
    onClickDay,
    getContent,
    searchTerms,
    showPianoRoll,
    bottomHeight
}) => { 
    let [results, setResults] = useState([]);
    let [isLoading, setIsLoading] = useState(false);
    let ref = useRef(undefined);
    let {size} = useScroll(ref, 30, true);

    useEffect(() => {
        let _id = ++id;
        setIsLoading(true);
        getContent(searchTerm)
            .then(r => {
                if (_id === id) {
                    setResults(r);
                    setIsLoading(false);
                }
            });
    }, [searchTerm, setResults, setIsLoading]);


    let style = {
        height: window.innerHeight - 233
    };
    if (showPianoRoll) {
        style.height -= bottomHeight - 150;
    }

    return (
        <div ref={ref} style={style} className="sound-grid">
          {isLoading ?
           <UnknownProgressBar text="Searching"/> : 
           results.slice(0, size).map(
               (dayResults, i) =>
                   <Day
                     key={"day-" + i}
                     onClickSource={onClickSource}
                     onClickDay={onClickDay}
                     results={dayResults}/>)}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentGrid);
